export const webStorePssClearAuth = () => {
  localStorage.removeItem("PssLogon");
  sessionStorage.removeItem("PssLogon");
};
